export default __webpack_public_path__ + "static/media/solteirotriplo_5.70535b02.jpg";